var map = {
	"./AI & Data.svg": 7699,
	"./AMA.svg": 1568,
	"./App & Web.png": 3331,
	"./App & Web.svg": 7992,
	"./Bio.svg": 5915,
	"./CC.svg": 3294,
	"./Cloud & cyber.svg": 5409,
	"./CodeBuddy.svg": 9976,
	"./Collaborate.svg": 9009,
	"./Communicate.svg": 4796,
	"./Communicate2.svg": 3726,
	"./DSC BPDC Dark Horizontal-Logo.png": 9070,
	"./DSC BPDC Dark Vertical-Logo.png": 2790,
	"./DSCBPDCHorizontal.png": 745,
	"./DSCBPDCOnlyLogo.svg": 6005,
	"./DSCBPDCVertical.png": 891,
	"./GDSCLogoText.png": 6864,
	"./Ideate (1).svg": 782,
	"./Ideate.svg": 6641,
	"./Robotics.svg": 7565,
	"./VerboseLog.svg": 5152,
	"./aiLogo.svg": 7793,
	"./bioLogo.svg": 5753,
	"./book.svg": 1323,
	"./bulb.svg": 1603,
	"./chat.png": 5695,
	"./cloudLogo.svg": 8734,
	"./code.svg": 6350,
	"./ctfLogo.svg": 9418,
	"./dsc_jig.svg": 5707,
	"./events-hero.svg": 8933,
	"./homepage_main.jpg": 4213,
	"./jig.svg": 1647,
	"./jigmobile.svg": 9165,
	"./person1.svg": 5442,
	"./person2.svg": 9548,
	"./person3.svg": 20,
	"./play.svg": 8215,
	"./podcast.svg": 1789,
	"./r1.svg": 5458,
	"./r2.svg": 5017,
	"./r3.svg": 7508,
	"./r4.svg": 5860,
	"./rev1.svg": 5944,
	"./rev2.svg": 4841,
	"./rev3.svg": 2710,
	"./rev4.svg": 9088,
	"./roboLogo.svg": 9575,
	"./spotify.svg": 2739,
	"./webLogo.svg": 2178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5837;